import React from 'react';
import Search from './search_bar/Search';
import Contact from './contact/contact';
import * as Lang from './utils/Lang';
import * as StockMarket from './stock_getter/StockGetter';
import Navbar from './navbar/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import GoogleAd from './google_ad/GoogleAd';
// import MainLogo from './Logo/Logo_b.png';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
	gtmId: 'GTM-KJCWX4F',
};

TagManager.initialize(tagManagerArgs);

class App extends React.Component {
	constructor() {
		super();
		this.state = {
			lang: Lang.HEBREW, // cahnge to english if button pressed
			stock_market: StockMarket.TASE_STOCK_FUNCTIONS, // cahnge to other stock if button pressed
		};
		this.change_lang = this.change_lang.bind(this);
	}

	change_lang() {
		// if (this.state.lang.NAME === 'ENGLISH') {
		// 	this.setState({ lang: Lang.HEBREW });
		// } else {
		// 	this.setState({ lang: Lang.ENGLISH });
		// }
	}

	componentDidMount() {}

	render() {
  
		// Extract out route config to constants
		const HOME_ROUTE = '/';
		const CONTACT_ROUTE = '/contact';
	  
		return (
		  <Router>
			<Navbar 
			  changeLang={this.changeLang}
			  text_lang={this.state.lang}  
			/>
	  
			<Routes>
	  
			  <Route 
				exact 
				path={HOME_ROUTE}
				element={
				  <Search
				  text_lang={this.state.lang}
				  stock_market={this.state.stock_market}
				  />
				} 
			  />
	  
			  <Route 
				exact
				path={CONTACT_ROUTE}
				element={<Contact />} 
			  />
	  
			</Routes>
		  </Router>
		);
	  
	  }
}
export default App;
